module.exports = __webpack_public_path__ + "static/media/1POLICY27.73831ba8.jpg";